import CurrencyFormatter from '../../../../../utils/currency-formatter-lib';
import SavedItemsModalSubview from './saved-items-modal';

export default class SavedItemsSubview {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.saved-items');
        this.templateSettings = { interpolate: /(?:<%=|{{)([\s\S]+?)(?:%>|}})/g };
        this.currency = window.HONDA.currency;
        this.templateSettings = { interpolate: /(?:<%=|{{)([\s\S]+?)(?:%>|}})/g };
        this.savedItemTemplate = this.getCompiledTemplate('#saved-item');
        this.noItemsTemplate = this.getCompiledTemplate('#no-items');
        this.utils = {
            formatPrice: new CurrencyFormatter().to,
            formatFinance: new CurrencyFormatter({ roundToDecimalPlace: +this.currency.roundToDecimalPlaceFinance || 0 }).to,
            formatAPR: (apr) => (apr ?? 0).toFixed(+this.currency.roundToDecimalPlaceFinanceAPR),
            pipeToSpace: (str) => str.replaceAll('|', ' '),
            capitalize: (str) => str && str[0].toUpperCase() + str.slice(1),
        };
        this.savedItemsModalSubview = this.parent.savedItemsModalSubview;
    }

    getCompiledTemplate(selector) {
        var templateStr = this.parent.el.querySelector(selector)?.innerHTML.replace(/\\/g, '');
        return templateStr ? _.template(templateStr, this.templateSettings) : null;
    }

    populate() {
        const count = this.count();
        const savedItems = HONDA?.SaveForLater?.saveForLater?.saved || [];
        const { utils } = this;
        const html = savedItems.map((item) => {
            const data = { ...item.data } ;
            Object.entries(data).forEach(([key, value]) => {
                if(typeof value === "string") {
                    data[key] = value.replace(/{([^}]+)}/g, '');
                }
            })

           return this.savedItemTemplate({ data, utils })
        }).join('');
        
        this.el.innerHTML = count > 0 ? html : this.noItemsTemplate();
        const removeCta = this.el.querySelectorAll('.remove-btn');
        if (removeCta.length > 0) {
            removeCta.forEach((button) => {
                button.addEventListener('click', () => {
                    const data = button.dataset;
                    if (data.savedId) {
                        this.savedItemsModalSubview.show(data.savedId);
                    }
                });
            });
        }
        this.parent.update();
    }

    count() {
        const savedItems = this.saveForLater();
        return savedItems ? savedItems.length : 0;
    }

    saveForLater() {
        const json = localStorage.getItem('save-for-later');
        try {
            return JSON.parse(json);
        } catch {
            return [];
        }
    }
}
